module.exports = __webpack_public_path__ + "static/example-date-picked-5ccb9483e94e43c5494e7b119b56e2cc.gif";